import { useFormContext } from "react-hook-form";

import { FileRow, SelectControllerRow } from "@components";

import { OtherAttachedFilesFormDataType } from "@validations/HRM/employee/attachedFiles";

export const UploadDocumentForm = ({
  userManualId,
  modules,
}: {
  userManualId?: number | string;
  modules: any;
}) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<OtherAttachedFilesFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <SelectControllerRow
        label="HRM_SETTINGS.USER_MANUAL.FORM.FIELDS.MODULE"
        control={control}
        name="moduleType"
        register={{
          ...register("moduleType", {
            required: "Module name is required",
          }),
        }}
        options={modules}
        setValue={setValue}
        error={errors}
        required
        disabled={userManualId ? true : false}
      />

      <FileRow
        {...register("document", {
          required: "Document is required",
        })}
        required
        name="document"
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
      />
    </div>
  );
};
